import { post, get } from '../../common/ApiClient';
import { UsernameResponse } from '../types/User';
import { LoggedInDevicesResponse } from '../types/Device';

type Data = {
  token: string;
};

export const getDevices = async (): Promise<any> => {
  try {
    const { data } = await get<LoggedInDevicesResponse>('/user/logged-in-devices', true);

    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const removeDevice = async (tokenData: Data): Promise<UsernameResponse> => {
  try {
    let formData = new FormData();
    formData.append('token', tokenData.token);

    const { data } = await post<UsernameResponse>('/user/logout-token', true, formData);

    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
